module.exports = __webpack_public_path__ + "img/googleplay-tr.39902c7c.svg";